module.exports = __webpack_public_path__ + "static/media/card-ads-mobile-br.0fa79fe8.png";